export default __webpack_public_path__ + "static/media/govGr.ccd64c27.svg";